//
// this file contains a lot of conversion functions between bsv, usd, eur, satoshis
//

import { getLog } from "./helpers"

//
export function fiat_to_sats(val_fiat, BSVfiat_pair) {
    return parseFloat(val_fiat / BSVfiat_pair * 1e8)
}
export const eur_to_sats = fiat_to_sats
export const usd_to_sats = fiat_to_sats
export function fiat_to_bsv(val_fiat, BSVfiat_pair) {
    return parseFloat(val_fiat / BSVfiat_pair)
}
export const eur_to_bsv = fiat_to_bsv
export const usd_to_bsv = fiat_to_bsv
export function sats_to_fiat(sats, BSVfiat_pair) {
    return parseFloat(sats / 1e8 * BSVfiat_pair)
}
export const sats_to_eur = sats_to_fiat
export const sats_to_usd = sats_to_fiat
export function bsv_to_fiat(bsv_val, BSVfiat_pair) {
    return parseFloat(bsv_val * BSVfiat_pair)
}
export const bsv_to_eur = bsv_to_fiat
export const bsv_to_usd = bsv_to_fiat
export function sats_to_bsv(sats) {
    return parseFloat(sats / 1e8)
}
export function bsv_to_sats(bsv_val) {
    return parseFloat(bsv_val * 1e8)
}



/** beware potentially returns a string !
 * Will fix down a number to some number of digits, instead of .toFixed(x) doing a rounding.
 * toFixedDown will not round the values like toFixed would, which is better for sending tokens
 */
export function toFixedDown(number, digits) {
    number = parseFloat(number) // for safety
    /* had a bug where if you call toFixedDown with parseFloat(1.5e-8)
    it will return "1.5" because of the '.' in it, so this line deals with that case */
    if (number.toString().includes('e')) return number.toFixed(2)
    var re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)"),
        m = number.toString().match(re)

    // toFixed() to add decimals like 0 => 0.00
    return m ? parseFloat(m[1]) : number.valueOf().toFixed(digits)
}


/**
 * remove scientific notation (no "2e-7")
 */
export function toFixed(x) {
    const log = (...args) => { console.log("toFixed(): ", ...args) }
    log(x)
    if (Math.abs(x) < 1.0) {
        var e = parseInt(x.toString().split('e-')[1]);
        if (e) {

            //x *= Math.pow(10,e-1); // problem 2e-7*1000=0.000019999999...
            //log("x=",x)
            x = parseInt(x.toString().split('e-')[0]) / 10

            x = '0.' + (new Array(e)).join('0') + x.toString().substring(2);
        }
    } else {
        var e = parseInt(x.toString().split('+')[1]);
        if (e > 20) {
            e -= 20;
            x /= Math.pow(10, e);
            x += (new Array(e + 1)).join('0');
        }
    }
    return x;
}


/**
 * this one uses toFixedDown() to display fixed-down version of eur values
 */
export function satoshis_to_eur(satoshis, bsvprice) {
    const function_id = "satoshis_to_eur(): "
    const log = getLog(function_id)

    var val_euro = parseFloat(satoshis / 1e8 * bsvprice) //.toFixed(2)

    if (val_euro < 1) {
        // find a nice way to display the fees in € by showing like 0.0009€ and not 0.002354316541€
        var val_euro_string = val_euro.toString()
        log("val_euro_string=", val_euro_string)
        var firstnonzeroidx = -1 // to account for "0."
        while (val_euro_string[0] === '0' || val_euro_string[0] === '.') {
            val_euro_string = val_euro_string.slice(1) // remove first char
            firstnonzeroidx++
        }
        if (firstnonzeroidx < 2) firstnonzeroidx = 2
        val_euro = val_euro.toFixed(firstnonzeroidx) // KEEP TOFIXED HERE EVEN AFTER YOU REMOVE ROUNDING EVERYWHERE ELSE
    }
    else {
        val_euro = toFixedDown(val_euro, 2)
    }
    return val_euro
}


export function eur_to_satoshis(eur_val, bsvprice) {
    const function_id = "eur_to_satoshis(): "
    const log = getLog(function_id)

    var val_satoshis = parseFloat(eur_val * 1e8 / bsvprice)

    return val_satoshis
}
